import Axios from "axios";
import { ApiResultModel } from "../models/common.model";
import { ApiBaseUrl, SaleUrl } from "../config/config";
import {
  IAddSaleItemRequest,
  ICancelInvoiceRequest,
  IDeleteInvoiceFileRequest,
  IDeleteSaleItemRequest,
  IGetByKeyResponse,
  IGetSaleItemGroupsRequest,
  IGetSaleItemGroupsResponse,
  IGetSaleItemsRequest,
  IInvoiceFiles,
  IInvoiceResponse,
  ISaleItem,
  ISaleItemRequest,
  ISaleItemResponse,
  IUploadInvoiceFileRequest,
  IVerifyInvoiceDetailsByCustomerRequest,
  IVerifyInvoiceDetailsByCustomerResponse,
  IWaitForConfirmRequestRequest,
} from "../models/sale.model";
import { SendOtpResponse } from "../models/security.model";

export const addSaleItem = (
  data: IAddSaleItemRequest
): Promise<ISaleItemResponse> => {
  return Axios.post<ApiResultModel<ISaleItemResponse>>(
    ApiBaseUrl + SaleUrl + "/AddSaleItem",
    data
  ).then((result) => {
    return result.data.data;
  });
};
export const getSaleItems = (
  data: IGetSaleItemsRequest
): Promise<ISaleItem[]> => {
  return Axios.post<ApiResultModel<ISaleItem[]>>(
    ApiBaseUrl + SaleUrl + "/GetSaleItems",
    data
  ).then((result) => {
    return result.data.data;
  });
};
export const getByKey = (
  data: ISaleItemRequest
): Promise<IGetByKeyResponse> => {
  return Axios.post<ApiResultModel<IGetByKeyResponse>>(
    ApiBaseUrl + SaleUrl + "/GetByKey",
    data
  ).then((result) => {
    return result.data.data;
  });
};
export const getOpenSaleItems = (
  data: ISaleItemRequest
): Promise<ISaleItem[]> => {
  return Axios.post<ApiResultModel<ISaleItem[]>>(
    ApiBaseUrl + SaleUrl + "/GetOpenSaleItems",
    data
  ).then((result) => {
    return result.data.data;
  });
};
export const cancelInvoice = (
  data: ICancelInvoiceRequest
): Promise<boolean> => {
  return Axios.post<ApiResultModel<boolean>>(
    ApiBaseUrl + SaleUrl + "/CancelInvoice",
    data
  ).then((result) => {
    return result.data.data;
  });
};
export const deleteSaleItem = (
  data: IDeleteSaleItemRequest
): Promise<ISaleItemResponse> => {
  return Axios.post<ApiResultModel<ISaleItemResponse>>(
    ApiBaseUrl + SaleUrl + "/DeleteSaleItem",
    data
  ).then((result) => {
    return result.data.data;
  });
};

export const sendRequestForInvoiceOtp = (
  data: ISaleItemRequest
): Promise<SendOtpResponse> => {
  return Axios.post<ApiResultModel<SendOtpResponse>>(
    ApiBaseUrl + SaleUrl + "/SendRequestForInvoiceOtp",
    data
  ).then((result) => {
    return result.data.data;
  });
};
export const verifyInvoiceDetailsByCustomer = (
  data: IVerifyInvoiceDetailsByCustomerRequest
): Promise<IVerifyInvoiceDetailsByCustomerResponse> => {
  return Axios.post<ApiResultModel<IVerifyInvoiceDetailsByCustomerResponse>>(
    ApiBaseUrl + SaleUrl + "/VerifyInvoiceDetailsByCustomer",
    data
  ).then((result) => {
    return result.data.data;
  });
};
export const uploadInvoiceFile = (
  data: IUploadInvoiceFileRequest
): Promise<IInvoiceFiles> => {
  const formData = new FormData();
  formData.append("file", data.file);
  formData.append("customerPersonId", data.customerPersonId + "");
  formData.append("branchId", data.branchId + "");
  formData.append("saleKey", data.saleKey + "");
  return Axios.post<ApiResultModel<IInvoiceFiles>>(
    ApiBaseUrl + SaleUrl + "/UploadInvoiceFile",
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data; charset=utf-8",
        Accept: "multipart/form-data",
      },
    }
  ).then((result) => {
    return result.data.data;
  });
};
export const deleteInvoiceFile = (
  data: IDeleteInvoiceFileRequest
): Promise<boolean> => {
  return Axios.post<ApiResultModel<boolean>>(
    ApiBaseUrl + SaleUrl + "/DeleteInvoiceFile",
    data
  ).then((result) => {
    return result.data.data;
  });
};
export const getSaleItemGroups = (
  data: IGetSaleItemGroupsRequest
): Promise<IGetSaleItemGroupsResponse[]> => {
  return Axios.post<ApiResultModel<IGetSaleItemGroupsResponse[]>>(
    ApiBaseUrl + SaleUrl + "/GetSaleItemGroups",
    data
  ).then((result) => {
    return result.data.data;
  });
};
export const waitForConfirmRequest = (
  data: IWaitForConfirmRequestRequest
): Promise<boolean> => {
  return Axios.post<ApiResultModel<boolean>>(
    ApiBaseUrl + SaleUrl + "/WaitForConfirmRequest",
    data
  ).then((result) => {
    return result.data.data;
  });
};
